import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { TamasAlunoService } from "../tamas-aluno.service";
import { BaseNotificacao } from "../tamas-models";
import * as moment from "moment";
import { AlertaSimplesDialog } from "../alerta-simples";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "app-me-notificacoes",
  templateUrl: "./me-notificacoes.component.html",
  styleUrls: ["./me-notificacoes.component.css"],
})
export class MeNotificacoesComponent implements OnInit {
  hideCL: boolean = false;
  arrNotificacoes: BaseNotificacao[] = [];
  arrNotify: BaseNotificacao[] = [];
  existemNotificacoes: boolean = false;
  qIndex: any = 0;
  loadMore: boolean = true;
  urlFoto: any = "";
  urlFotoFeed: any = "";
  constructor(
    private route: ActivatedRoute,
    private _location: Location,
    public router: Router,
    public tmaService: TamasAlunoService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.carregarNotificacoes();
    this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
    this.urlFotoFeed = this.tmaService.urlRepositorioS3 + "/users-feed/";
  }

  carregarNotificacoes(): void {
    this.hideCL = false;
    var gDados =
      "email=" +
      this.tmaService.hcEmail +
      "&senha=" +
      this.tmaService.hcSenha +
      "&meuindex=" +
      this.qIndex;
    this.tmaService.listarNotificacoes(gDados).subscribe((qRes) => {
      //console.log(qRes);
      this.hideCL = true;
      if (qRes["res"] == "done") {
        //this.arrNotificacoes = qRes['arrTreinos'];
        if (
          qRes["planos"].length == 0 &&
          qRes["social"].length == 0 &&
          qRes["requisicao"].length == 0 &&
          qRes["loja"].length == 0 &&
          qRes["promo"].length == 0
        ) {
          this.loadMore = false;
        }
        if (qRes["planos"].length > 0) {
          //percorrer e inserir no array
          qRes["planos"].forEach((item) => {
            var qHora = moment(
              item.HoraNotificacao.Hours + ":" + item.HoraNotificacao.Minutes,
              "HH:mm"
            ).format("HH:mm");
            var qData = moment(item.DataNotificacao).format("DD-MM-YYYY");
            //console.log(qHora);

            //console.log(moment("/Date(1601471908921)/").format("DD/MM/YYYY HH:mm"));
            //console.log(moment(item.DataNotificacao).format("DD/MM/YYYY HH:mm"));
            //console.log(moment(item.datafull).format("DD/MM/YYYY HH:mm"));

            this.arrNotificacoes.push({
              Id: item.Id,
              Titulo: item.Titulo,
              Tipo: "Plano",
              QTipo: item.Tipo,
              QAct: item.Acao2,
              Separador: "p",
              Visualizado: item.Visualizado,
              Data: item.datafull,
              DataF: moment(item.datafull).format("DD/MM/YYYY"),
              Hora: moment(
                item.HoraNotificacao.Hours + ":" + item.HoraNotificacao.Minutes,
                "HH:mm"
              ).format("HH:mm"),
              Foto: "",
            });
          });
        }

        if (qRes["social"].length > 0) {
          qRes["social"].forEach((item) => {
            this.arrNotificacoes.push({
              Id: item.Id,
              Titulo: item.Titulo,
              Tipo: "Social",
              Separador: "s",
              Visualizado: item.Visualizado,
              Data: item.datafull,
              Hora: moment(
                item.HoraNotificacao.Hours + ":" + item.HoraNotificacao.Minutes,
                "HH:mm"
              ).format("HH:mm"),
              DataF: moment(item.datafull).format("DD/MM/YYYY"),
              Foto: item.foto,
              IdPublicacao: item.IdPublicacao,
              NickReagiu: item.NickReagiu,
              QTipo: item.Tipo,
              ImagemPub: item.ImgPub,
              QAct: item.Acao,
            });
          });
        }

        if (qRes["requisicao"].length > 0) {
          qRes["requisicao"].forEach((item) => {
            this.arrNotificacoes.push({
              Id: item.Id,
              Titulo: item.Titulo,
              Tipo: "Requisição",
              Separador: "r",
              Visualizado: item.Visualizado,
              Data: item.datafull,
              Hora: moment(
                item.HoraNotificacao.Hours + ":" + item.HoraNotificacao.Minutes,
                "HH:mm"
              ).format("HH:mm"),
              DataF: moment(item.datafull).format("DD/MM/YYYY"),
              Foto: "",
            });
          });
        }

        if (qRes["loja"].length > 0) {
          qRes["loja"].forEach((item) => {
            this.arrNotificacoes.push({
              Id: item.Id,
              Titulo: item.Titulo,
              Tipo: "Loja",
              Separador: "l",
              Visualizado: item.Visualizado,
              Data: item.datafull,
              Hora: moment(
                item.HoraNotificacao.Hours + ":" + item.HoraNotificacao.Minutes,
                "HH:mm"
              ).format("HH:mm"),
              DataF: moment(item.datafull).format("DD/MM/YYYY"),
              Foto: "",
            });
          });
        }

        if (qRes["promo"].length > 0) {
          qRes["promo"].forEach((item) => {
            this.arrNotificacoes.push({
              Id: item.Id,
              Titulo: item.Titulo,
              Tipo: "Promo",
              QTipo: item.Tipo,
              Separador: "c",
              Visualizado: item.Visualizado,
              Data: item.datafull,
              Hora: moment(
                item.HoraNotificacao.Hours + ":" + item.HoraNotificacao.Minutes,
                "HH:mm"
              ).format("HH:mm"),
              DataF: moment(item.datafull).format("DD/MM/YYYY"),
              Foto: "",
            });
          });
        }

        this.arrNotify = this.arrNotificacoes.sort(
          (a: BaseNotificacao, b: BaseNotificacao) => {
            //console.log("a " +  a.Titulo);
            //console.log("b " +  b.Titulo);
            //var horaA = a.Hora
            return moment(b.Data).unix() - moment(a.Data).unix();
          }
        );

        // console.log(this.arrNotificacoes);
        // setTimeout(() => {
        //   console.log("bora");
        // }, 2000);
        // console.log("array ");
        // console.log(this.arrNotify);

        this.qIndex += 10;
        if (this.arrNotificacoes.length > 0) {
          this.existemNotificacoes = true;
        } else {
          this.existemNotificacoes = false;
        }
      }
    });
  }

  goNotificacao(tipo: any, id: any, vi: boolean): void {
    if (!vi) {
      var qtyN = this.tmaService.hcNotify - 1;
      this.tmaService.notifyQtyhange.next(qtyN);
      var idpub2 = this.arrNotificacoes.find((x) => x.Id == id).IdPublicacao;
      if (tipo == "s" && idpub2 != null && idpub2 != 0) {
        let customParams = {
          idusuario: this.tmaService.hcUid,
          idnotificacao: id,
          idpublicacao: idpub2,
        };

        this.tmaService.notificacaoVisuali(customParams).subscribe();
      }
    }

    if (tipo == "s") {
      var idpub = this.arrNotificacoes.find((x) => x.Id == id).IdPublicacao;
      // var nick = this.arrNotificacoes.find(x => x.Id == id).NickReagiu;
      if (idpub != null && idpub != 0) {
        this.tmaService.gUrlAnterior = "/me/notificacoes";
        this.tmaService.socialTipo = this.arrNotificacoes.find(
          (x) => x.Id == id
        ).QTipo;
        this.router.navigate([
          "/me/post/" + this.tmaService.hcNomeUsuario + "/" + idpub,
        ]);
      } else {
        this.router.navigate(["/me/notificacao/" + tipo + "/" + id]);
      }
    } else {
      this.router.navigate(["/me/notificacao/" + tipo + "/" + id]);
    }
  }

  goPerfil(nick: any) {
    this.tmaService.gUrlAnterior = "/me/notificacoes";
    this.router.navigate(["/" + nick]);
  }

  autorizarTorcedor(nickusuario: any, idNotificacao: number): void {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      nomeusuario: nickusuario,
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
    };
    this.tmaService.autorizarTorcedor(customParams).subscribe(
      (qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes["res"] == "done") {
          const aceiteDone = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              textoAlerta: "Operação realizada com sucesso",
              tituloAlerta: "Autorizado",
              iconAlerta: "",
            },
          });
          //check status following
          this.arrNotificacoes.find((x) => x.Id == idNotificacao).Following =
            qRes["following"];

          this.arrNotificacoes.find((x) => x.Id == idNotificacao).QAct = "done";

          if (qRes["following"] == true) {
          } else {
          }
        } else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: {
              tituloAlerta: "Aviso",
              textoAlerta:
                "Ocorreu um erro ao realizar esta operação Tente novamente",
              iconAlerta: "warning",
            },
          });
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: {
            tituloAlerta: "Aviso",
            textoAlerta:
              "Verifique sua conexão com a internet. Tente novamente",
            iconAlerta: "warning",
          },
        });
      }
    );
  }
}
